// ChangePasswordForm.js
import React, { useState } from "react";

const ChangePasswordForm = ({
  email,
  onSubmit,
  onBackToLogin,
  logoURL,
  clientDescription,
  isMobile,
  message,
  setMessage,
}) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setPasswordError("New passwords do not match.");
      return;
    }

    setPasswordError("");
    setMessage(""); // clear previous messages
    const result = await onSubmit(oldPassword, newPassword);

    if (result === "Error") {
      setMessage("Information provided incorrect!");
    } else {
      setMessage("Password successfully changed!");
    }
  };

  const isSuccess =
    message &&
    (message.toLowerCase().includes("success") ||
      message.toLowerCase().includes("ok"));

  return (
    <div className="inner-form-container">
      <h2>{clientDescription}</h2>
      <img
        src={logoURL ? `${logoURL}` : "https://placehold.co/250x250/png"}
        alt="Brand Logo"
        className="branding-image"
      />
      <h2>Change Password</h2>

      {message && (
        <div className={isSuccess ? "success-box" : "error-box"}>{message}</div>
      )}

      <form onSubmit={handleFormSubmit} className="form">
        <label className="label">
          Temporary Password:
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            className="input"
            placeholder="Enter temporary password"
          />
        </label>

        <label className="label">
          New Password:
          <input
            type="password"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setPasswordError("");
            }}
            required
            className="input"
            placeholder="Enter new password"
          />
        </label>

        <label className="label">
          Confirm New Password:
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setPasswordError("");
            }}
            required
            className="input"
            placeholder="Re-enter new password"
          />
        </label>

        {passwordError && <div className="error-message">{passwordError}</div>}

        <button type="submit" className="login-button">
          Update Password
        </button>

        <button
          type="button"
          onClick={onBackToLogin}
          className="register-button"
        >
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordForm;
